import * as types from '../../constants/actionsType'

const initialState = {
    dailyTrend: [],
    dailyTrendLoader: false,
    weeklyTrend: [],
    weeklyTrendLoader: false,
    cardData: [],
    cardDataLoader: false,
    mostActiveProj: [],
    mostActiveProjLoader: false,
    mostActiveEmp: [],
    mostActiveEmpLoader: false,
    utilizationChart: [],
    utilizationChartLoader: false
}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.DAILY_TREND_CAP_DASHBOARD:
            return {
                ...state,
                dailyTrend: action.data
            }
        case types.WEEK_TREND_CAP_DASHBOARD:
            return {
                ...state,
                weeklyTrend: action.data
            }
        case types.CARD_DATA_CAP_DASHBOARD:
            return {
                ...state,
                cardData: action.data
            }
        case types.MOST_ACTIVE_PROJ_CARD_DATA_CAP_DASHBOARD:
            return {
                ...state,
                mostActiveProj: action.data
            }
        case types.MOST_ACTIVE_EMP_CARD_DATA_CAP_DASHBOARD:
            return {
                ...state,
                mostActiveEmp: action.data
            }
        case types.UTILIZATION_CURRENT_MONTH_CAP_DASHBOARD:
            return {
                ...state,
                utilizationChart: action.data
            }
        case types.DAILY_TREND_LOADER_CAP_DASHBOARD:
            return {
                ...state,
                dailyTrendLoader: action.data
            }
        case types.WEEK_TREND__LOADER_CAP_DASHBOARD:
            return {
                ...state,
                weeklyTrendLoader: action.data
            }
        case types.CARD_DATA__LOADER_CAP_DASHBOARD:
            return {
                ...state,
                cardDataLoader: action.data
            }
        case types.MOST_ACTIVE_PROJ__LOADER_CARD_DATA_CAP_DASHBOARD:
            return {
                ...state,
                mostActiveProjLoader: action.data
            }
        case types.MOST_ACTIVE_EMP__LOADER_CARD_DATA_CAP_DASHBOARD:
            return {
                ...state,
                mostActiveEmpLoader: action.data
            }
        case types.UTILIZATION_CURRENT_MONTH__LOADER_CAP_DASHBOARD:
            return {
                ...state,
                utilizationChartLoader: action.data
            }
        default:
            return state
    }
}
export default reducer
